// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Limite de erro de render
//
// Substitui o handler que existia em index.js, que tinha três problemas:
//
//  1. Apagava a página inteira (document.body.innerHTML = ...) em QUALQUER
//     erro de window — inclusive erro vindo do script de planilha do CDN
//     (#20) e de extensão de navegador. Um erro alheio derrubava a sessão
//     com trabalho não salvo junto.
//  2. Injetava e.message e e.filename em innerHTML sem escapar.
//  3. Rodava antes do React, então nenhum limite de erro do React chegava
//     a ser consultado.
//
// Um limite de erro do React resolve os três: pega só o que quebrou no
// render, mantém o resto da aplicação viva, e o texto passa por JSX, que
// escapa por construção.
// ═══════════════════════════════════════════════════════════════════
import React from "react";
import { T, syne, mono } from "../../theme/tokens";
import { capturarErro } from "../../lib/observabilidade";

export class LimiteDeErro extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, id: null };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    // O id do evento vira o número que o operador informa no chamado — é
    // o que liga "deu erro na tela de notas" ao stack trace exato.
    const id = capturarErro(erro, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
    this.setState({ id });
    console.error("[erro de render]", erro, info?.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;

    const { id } = this.state;

    return (
      <div className="fu" style={{
        minHeight: "60vh", display: "flex", alignItems: "center",
        justifyContent: "center", padding: 24,
      }}>
        <div style={{
          maxWidth: 520, textAlign: "center",
          background: T.card, border: `1px solid ${T.border}`,
          borderRadius: 12, padding: "32px 28px",
        }}>
          <div style={{ fontSize: 30, marginBottom: 12 }}>⚠️</div>

          <div style={{ fontSize: 17, fontWeight: 800, color: T.text, ...syne }}>
            Esta tela falhou
          </div>

          <div style={{ fontSize: 13, color: T.sub, marginTop: 10, lineHeight: 1.6 }}>
            O restante do sistema continua funcionando — troque de aba pelo menu
            ou recarregue esta tela. Nada do que você já salvou foi perdido.
          </div>

          {id && (
            <div style={{
              marginTop: 18, padding: "10px 14px", borderRadius: 8,
              background: T.bg, border: `1px solid ${T.border}`,
              fontSize: 11, color: T.muted,
            }}>
              <div style={{ marginBottom: 4 }}>Informe este código no chamado:</div>
              <div style={{ ...mono, fontSize: 12, color: T.text }}>{id}</div>
            </div>
          )}

          {/* Detalhe técnico só fora de produção: em produção a mensagem de
              erro pode conter dado de nota ou de cliente. */}
          {process.env.NODE_ENV !== "production" && (
            <pre style={{
              marginTop: 16, padding: 12, borderRadius: 8, textAlign: "left",
              background: T.bg, border: `1px solid ${T.border}`,
              fontSize: 11, color: T.red, whiteSpace: "pre-wrap",
              maxHeight: 180, overflow: "auto", ...mono,
            }}>{String(this.state.erro?.stack || this.state.erro)}</pre>
          )}

          <button
            type="button"
            className="m-toque"
            onClick={() => this.setState({ erro: null, id: null })}
            style={{
              marginTop: 20, padding: "9px 22px", borderRadius: 8, border: "none",
              background: T.red, color: "#fff", cursor: "pointer",
              fontWeight: 700, fontSize: 13,
            }}
          >
            Tentar de novo
          </button>
        </div>
      </div>
    );
  }
}
